function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.316.22v2.266h4.531v11.326h2.265V2.486h4.531V.22zM0 .22v13.592h10.03v-2.265H2.265V8.149h6.747V5.884H2.265V2.486h7.765V.22zM39.234.22v5.664h-6.795V.22h-2.266v13.59h2.266V8.15h6.795v5.663h2.265V.22zM58.833 1.502a4.948 4.948 0 0 0-6.998 0c-.28.28-.861.934-1.06 1.256a4.943 4.943 0 0 1 6.818 6.777l.076-.076c.331-.201.878-.672 1.164-.958a4.949 4.949 0 0 0 0-6.999Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.444 9.892c-1.944-1.944-3.135-5.52-.941-9.301l-1.026 1.026A7.243 7.243 0 0 0 58.72 11.859l1.026-1.026c-3.601 2.093-7.184 1.177-9.302-.94ZM69.975 14.017c3.29 0 5.416-1.63 5.416-4.154 0-2.365-1.662-3.221-4.346-3.834l-1.643-.36c-1.48-.327-2.283-.708-2.283-1.78 0-1.093 1.02-1.8 2.596-1.8 1.47 0 2.766.547 3.563 1.502l1.707-1.372c-.94-1.016-2.597-2.202-5.21-2.202-2.953 0-5.096 1.679-5.096 3.993 0 2.64 2.162 3.446 4.046 3.853l1.824.402c1.442.313 2.402.742 2.402 1.819 0 1.157-1.04 1.82-2.855 1.82-1.98 0-3.475-.973-4.102-1.953L64.12 11.3c.964 1.322 2.997 2.717 5.854 2.717"
}));

function SvgWoodmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 15,
    viewBox: "0 0 76 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ethos Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodmark);
export default __webpack_public_path__ + "static/media/woodmark.df6fb12d.svg";
export { ForwardRef as ReactComponent };